import { defineMessages } from 'react-intl';

export default defineMessages({
  deviceScanningModalTitle: {
    id: 'common.modals.deviceScanningModalTitle',
    defaultMessage: '{deviceName}',
  },
});
